/* eslint-disable react/display-name */
import React from 'react';

import { AdminLayout } from 'ui/components/layouts';
import { Tab, TabList, TabPanel, Tabs } from 'ui/components/styled';
import { JobLogs } from './JobLogs';
import { UserLogs } from './UserLogs';

export const Logs = () => {
  const [index, setIndex] = React.useState(0);

  return (
    <AdminLayout>
      <Tabs selectedIndex={index} onSelect={(idx) => setIndex(idx)} isHorizontal>
        <TabList isHorizontal>
          <Tab>User logs</Tab>
          <Tab>Monitor logs</Tab>
        </TabList>
        <TabPanel isHorizontal>
          <UserLogs />
        </TabPanel>
        <TabPanel isHorizontal>
          <JobLogs />
        </TabPanel>
      </Tabs>
    </AdminLayout>
  );
};
